import { Subscription } from 'rxjs';
import { format } from 'date-fns';
import {Component, Input, OnDestroy, OnInit, SimpleChanges, ViewEncapsulation} from '@angular/core';
import {Atributo, Campo} from '../../../models/coleta';
import {INPUT_TYPES, PROPRIEDADES, REGEX_TEXTO_ALFABETICO} from '../util/constants';
import {AppValidators} from '../util/validators';
import {UntypedFormControl} from '@angular/forms';
import {last} from 'lodash';
import { FormatService } from 'src/app/services/format.service';

@Component({
  selector: 'app-input-text',
  templateUrl: './input-text.component.html',
  styleUrls: ['./input-text.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class InputTextComponent {

  internalCampo: Campo = {};
  placeholder: any;
  mask: any;
  name = '';
  decimal = false;
  numeric = false;
  isAlfanumerico = false;
  
  minlength: number | null = null;
  maxlength: number | null = null;

  formatType: string = 'CELULAR';
  
  @Input()
  currentFormControl: UntypedFormControl = new UntypedFormControl();

  @Input()
  readOnly = false;

  @Input()
  isCepLoading = false;
  
  @Input()
  requestFocus = false;

  @Input()
  numericKeyboard = false;

  @Input()
  doTrim = false;

  @Input()
  set campo(campo: Campo) {

    this.name = campo.codigo || '';
    this.decimal = campo.tipo === INPUT_TYPES.DECIMAL;
    this.isAlfanumerico = campo.tipo === INPUT_TYPES.ALFANUMERICO;
    this.numericKeyboard = [INPUT_TYPES.NUMERIC, INPUT_TYPES.DECIMAL, INPUT_TYPES.DATE, INPUT_TYPES.INTEGER].includes(campo.tipo ?? '');
    this.doTrim = !this.numericKeyboard;

    const mask: Atributo | undefined = campo.atributos?.find((item) => item.propriedade === PROPRIEDADES.MASCARA);
    this.minlength = Number(campo.atributos?.find((item) => item.propriedade === PROPRIEDADES.MINIMO)?.valor) || null;
    this.maxlength = Number(campo.atributos?.find((item) => item.propriedade === PROPRIEDADES.MAXIMO)?.valor) || null;
    this.internalCampo = campo;
    this.updateMask();
  }

  get campo(): Campo {
      return this.internalCampo;
  }

  constructor(private formatService: FormatService){
      this.formatService.formatType$.subscribe(valor => {
      this.formatType = valor;
      this.updateMask();

    })
  }

  private updateMask(): void {
    const mask: Atributo | undefined = this.internalCampo.atributos?.find((item) => item.propriedade === PROPRIEDADES.MASCARA);
    if (mask) {
      let maskValue: string = '';  
        if ((this.formatType == 'RESIDENCIAL') || (this.formatType == 'COMERCIAL') || (this.formatType == 'OUTRO')) {
        maskValue = mask.valor.split('||')[0] || '';
      } else {
        maskValue = last(mask.valor.split('||')) || '';
      }

      if (this.internalCampo.tipo === INPUT_TYPES.ALFANUMERICO) {
        this.mask = maskValue.replace(/\?/g, 'A').replace(/#/g, '0');
        this.placeholder = '';
      } else {
        this.placeholder = maskValue.replace(/#/g, '0');
        this.mask = this.placeholder;
      }
    } else {
      this.placeholder = this.internalCampo.atributos?.find((item) => item.propriedade === PROPRIEDADES.PLACEHOLDER)?.valor;
      this.mask = undefined;
    }
  }

  isInvalid(): boolean{
    return !!this.currentFormControl?.invalid;
  }

  getErrorMessage(): string {
    return AppValidators.errorMessage(this.currentFormControl);
  }

  @Input()
  customFunctionality: boolean = false; // Nova variável de controle

  keyPressFilter(event: any) {
    if(this.campo.tipo == INPUT_TYPES.ALPHA) {
      var inp = String.fromCharCode(event.keyCode);
      
      if (REGEX_TEXTO_ALFABETICO.test(inp)) {
        return true;
      } else {
        event.preventDefault();
        return false;
      }
    } 
    return true;
  }  

}